import React from 'react';
import api from '../../../../store/api';
import CalloutStatuses from '../../types/CalloutStatuses';
import ChooseDialogPage1 from './ChooseDialogPage1';
import ChooseDialogPage2 from './ChooseDialogPage2';
import AmbulanceDialogPage3 from './AmbulanceDialogPage3';

interface EndCalloutRequest {
    requestCalloutId: string,
    reasonForCalloutNote?: string | null | undefined,
    reasonForCalloutId?: string | null | undefined,
    isTransferredViaAmbulance: boolean,
    transferViaAmbulanceNote: string,
    status: number
};

// requriments expectations that this code will be copied with some refactoring
const ChooseCalloutReason = ({ requestCalloutIdForFinishStateArray, setPage: setPageOuter }: any) => {
    const [page, setPage] = React.useState(1);
    const [reasonList, setReasonList] = React.useState<{ reasonForCalloutId: string, name: string }[]>([]);
    const [calloutReasonValuesObj, setCalloutReasonValuesObj] = React.useState<any>(null);

    const [requestCalloutIdForFinish, setRequestCalloutIdForFinish] = requestCalloutIdForFinishStateArray as Array<any>;

    React.useEffect(() => {
        api.getReasonsForCalloutUser("").then((res: any) => {
            setReasonList(res?.data?.model || []);
        });
    }, []);

    const endCallout = async (ambulanceValuesObj: any) => {
        try {
            const requestObj: EndCalloutRequest = {
                status: CalloutStatuses.teamDeparted,
                requestCalloutId: requestCalloutIdForFinish,
                isTransferredViaAmbulance: ambulanceValuesObj.transferdViaAmbulance === 'yes',
                transferViaAmbulanceNote: ambulanceValuesObj.notes
            };
            if (calloutReasonValuesObj) {
                requestObj.reasonForCalloutId = calloutReasonValuesObj.calloutReason === "Other" ? null : calloutReasonValuesObj.calloutReason;
                requestObj.reasonForCalloutNote = calloutReasonValuesObj.otherreason;
            }
            await api.updateRequestCallout('',requestObj);
        } catch (error) {
            console.error(error);
        }
        setRequestCalloutIdForFinish('');
        setPageOuter(0);
    }

    const cancelEndCallout = () =>{
        setRequestCalloutIdForFinish('');
        setPageOuter(0);
    }

    const goToAmbulanceDialog = () => {
        setPage(3);
    }

    switch (page) {
        case 2:
            return (
                <ChooseDialogPage2
                    setPage={setPage}
                    goToAmbulanceDialog={goToAmbulanceDialog}
                    reasonList={reasonList}
                    calloutReasonValuesObj={calloutReasonValuesObj}
                    setCalloutReasonValuesObj={setCalloutReasonValuesObj}
                    cancelEndCallout={cancelEndCallout}
                />
            );
        case 3:
            return (
                <AmbulanceDialogPage3
                    setPage={setPage}
                    endCallout={endCallout}
                    cancelEndCallout={cancelEndCallout}
                    calloutReasonValuesObj={calloutReasonValuesObj}
                />
            );
        default:
            return (
                <ChooseDialogPage1
                    setCalloutReasonValuesObj={setCalloutReasonValuesObj} 
                    setPage={setPage} 
                    goToAmbulanceDialog={goToAmbulanceDialog}
                    cancelEndCallout={cancelEndCallout} 
                />
            );
    }
};

export default ChooseCalloutReason;